import { breakpoints, respondTo } from "@/respondTo";
import { Box } from "@mui/material";
import Styled from "styled-components";
import { styled as muiStyle } from "@mui/material";

export const MainSupportContainer = muiStyle(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  padding: "1.5rem 1rem",
  color: theme.palette.common.corporateColors.primary.white,

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "1.5rem",
  },
  [theme.breakpoints.up("xl")]: {
    padding: "1.5rem 2rem",
  },
}));

export const InnerContainer = muiStyle(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  gap: "1.25rem",

  [theme.breakpoints.up("md")]: {
    gap: "2.5rem",
    alignItems: "flex-start",
  },
}));

export const HeroContainer = Styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.625rem;
   `;

export const Img = Styled.img`
    width: 5rem;
    height: 100%;

    ${respondTo.desktop`
    width: 6.25rem;
    `}
    `;

export const ContactInfo = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0.625rem;

    `;

export const BtnContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.75rem;
 
    ${respondTo.tablet_landscape_s`
    align-items: flex-end;
    justify-content: flex-end;
    `}

    ${respondTo.desktop`
    align-items: flex-end;
    justify-content: flex-end;
    gap: 0.625rem;
    `}  
    `;

export const PrivacyConsent = Styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    color: inherit;

    ${respondTo.tablet_landscape_s`
    align-self: flex-end;
    `}
    `;

export const QuestionP = Styled.p`
    display: flex;
    align-self: flex-start;
    justify-content: flex-start;
    gap: 0.625rem;

    ${respondTo.tablet_landscape_s`
    align-self: center;
    justify-content: center;
    `}
`;
